import TextInput, { InputProps } from 'components/text-input';
import user from 'assets/images/user.svg';

type UserInputProps = Omit<InputProps, 'icon'>;

const UserInput: React.FC<UserInputProps> = (props) => {
  return <TextInput icon={user} {...props} />;
};

export default UserInput;
